var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-auth-page__head"},[_c('h1',[_vm._v(_vm._s(_vm.$t('h1')))])]),_vm._m(0),_c('div',[_c('div',{staticClass:"action-button",on:{"click":_vm.logout}},[_vm._v("Выйти")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://driver.deliver.ru/bargains"}},[_vm._v("Перейти на платформу Deliver")])])
}]

export { render, staticRenderFns }